import { IIconBase } from '..'

const hiperlinkIcon = ({
  color = '#333752',
  height = 14,
  width = 14,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_4105_21153)'>
        <rect width={width} height={height} fill='white' fillOpacity='0.01' />
        <path
          d='M7.58301 6.41669L12.3663 1.63336'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12.8332 3.96669V1.16669H10.0332'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M6.41699 1.16669H5.25033C2.33366 1.16669 1.16699 2.33335 1.16699 5.25002V8.75002C1.16699 11.6667 2.33366 12.8334 5.25033 12.8334H8.75033C11.667 12.8334 12.8337 11.6667 12.8337 8.75002V7.58335'
          stroke={color}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_4105_21153'>
          <rect width={width} height={height} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default hiperlinkIcon
